import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import {
  AppBar,
  Box,
  Button,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import MaterialReactTable from "material-react-table";
import { getData } from "../../../../services/library";
import { verEnviarPDFenvasado } from "../../../../services/services";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import BlockIcon from "@mui/icons-material/Block";
import AnularFactura from "../../facturados/anularFactura/AnularFactura";
import AnularFacturasRemitos from "./AnularFacturasRemitos/AnularFacturasRemitos";

const formatFecha = (fecha) => {
  if (!fecha) return "-";
  const date = new Date(fecha);
  if (Number.isNaN(date.getTime())) return "-";
  return `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${date.getFullYear()}`;
};

const formatComprobante = (row) => {
  if (!row.pto_venta || !row.nro_comprobante) return "-";
  const ptoVenta = row.pto_venta.toString().padStart(4, "0");
  const nroComprobante = row.nro_comprobante.toString().padStart(8, "0");
  return `${ptoVenta}-${nroComprobante}`;
};

const primerDiaDelMes = () => {
  const hoy = new Date();
  return new Date(hoy.getFullYear(), hoy.getMonth(), 1)
    .toISOString()
    .split("T")[0];
};

const hoyFormato = () => new Date().toISOString().split("T")[0];

function RemitosFacturados() {
  const location = useLocation();
  let navigate = useNavigate();
  const onBack = () => navigate(-1);

  const [facturas, setFacturas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [desde, setDesde] = useState(primerDiaDelMes());
  const [hasta, setHasta] = useState(hoyFormato());
  const [anularFactura, setAnularFactura] = useState(false);
  const [rowFactura, setRowFactura] = useState();

  const obtenerFacturas = async () => {
    setLoading(true);
    try {
      await getData(
        `/envasado_pedidos/remitosfacturados/${desde} 00:00:00/${hasta} 23:59:59/${location.state.id}`,
        setFacturas,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    obtenerFacturas();
  }, []);

  const facturasAgrupadas = useMemo(() => {
    const grupos = new Map();
    (facturas ?? []).forEach((row) => {
      if (!grupos.has(row.id_factura)) {
        grupos.set(row.id_factura, {
          id_factura: row.id_factura,
          pto_venta: row.pto_venta,
          nro_comprobante: row.nro_comprobante,
          letra: row.letra,
          texto_comprobante: row.texto_comprobante,
          fecha_emision: row.fecha_emision,
          facturado_a: row.facturado_a,
          remitos: [],
          id_estado: row.id_estado,
          id_nc: row.id_nc
        });
      }
      grupos.get(row.id_factura).remitos.push({
        id: row.id,
        origen: row.origen,
        remito_entrega: row.remito_entrega,
        fecha_para: row.fecha_para,
        direccion_entrega: row.direccion_entrega,
        producto:row.producto
      });
    });
    return Array.from(grupos.values());
  }, [facturas]);


  const handleCloseAnular = () => {
    setAnularFactura(false);
    obtenerFacturas();
  };

  const handleAnularFactura = (row) => {
    setAnularFactura(true);
    setRowFactura({
      id:row.id_factura
    });
  };

  const columns = useMemo(
    () => [
      {
        accessorFn: (row) => formatComprobante(row),
        id: "comprobante",
        header: "Comprobante",
        size: 140,
      },
      {
        accessorKey: "texto_comprobante",
        header: "Tipo",
        size: 160,
      },
      {
        accessorKey: "letra",
        header: "Letra",
        size: 80,
        Cell: ({ cell }) =>
          cell.getValue() ? (
            <Chip label={cell.getValue()} size="small" color="primary" />
          ) : (
            "-"
          ),
      },
      {
        accessorFn: (row) => formatFecha(row.fecha_emision),
        id: "fecha_emision",
        header: "Fecha Emisión",
        size: 120,
      },
      {
        accessorKey: "facturado_a",
        header: "Facturado A",
        size: 220,
      },
      {
        accessorFn: (row) => row.remitos.length,
        id: "cant_remitos",
        header: "Remitos",
        size: 100,
        Cell: ({ cell }) => (
          <Chip
            icon={<LocalShippingIcon />}
            label={cell.getValue()}
            size="small"
            variant="outlined"
          />
        ),
      },
    ],
    [],
  );
console.log("facturasAgrupadas",facturasAgrupadas, facturas);

  return (
    <div>
      <AppBar
        sx={{ position: "relative" }}
        style={{ backgroundColor: "#0979b0" }}
      >
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={onBack}>
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Remitos facturados de {location.state.razon_social}
          </Typography>
        </Toolbar>
      </AppBar>

      <div style={{ padding: "10px" }}>
        <Paper
          elevation={0}
          sx={{ p: 2, mb: 1.5, border: "1px solid #e0e0e0", borderRadius: 1 }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={5}>
              <TextField
                fullWidth
                size="small"
                label="Desde"
                type="date"
                value={desde}
                onChange={(e) => setDesde(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ bgcolor: "#fff" }}
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <TextField
                fullWidth
                size="small"
                label="Hasta"
                type="date"
                value={hasta}
                onChange={(e) => setHasta(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ bgcolor: "#fff" }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Button
                fullWidth
                variant="contained"
                onClick={obtenerFacturas}
                disabled={loading}
                startIcon={<RefreshIcon />}
                sx={{ py: 0.75, textTransform: "none", fontWeight: 500 }}
              >
                {loading ? "Cargando..." : "Buscar"}
              </Button>
            </Grid>
          </Grid>
        </Paper>

        {loading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="30vh"
          >
            <CircularProgress />
          </Box>
        ) : (
          <MaterialReactTable
            localization={MRT_Localization_ES}
            columns={columns}
            data={facturasAgrupadas}
            getRowId={(row) => row.id_factura}
            layoutMode="grid"
            initialState={{
              density: "compact",
              showGlobalFilter: true,
              pagination: { pageIndex: 0, pageSize: 10 },
            }}
            enableColumnActions={false}
            enableGlobalFilterModes={false}
            enableHiding={false}
            enableRowActions={true}
            enableColumnFilters={false}
            enableFullScreenToggle={false}
            positionActionsColumn="last"
            enableExpandAll={false}
            enableToolbarInternalActions={true}
            renderDetailPanel={({ row }) => (
              <Box sx={{ bgcolor: "#fafafa", p: 2 }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  Remitos incluidos en este comprobante
                </Typography>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Remito</TableCell>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Fecha Entrega
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Dirección de Entrega
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Productos
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.original.remitos.map((remito) => (
                      <TableRow key={`${remito.origen}-${remito.id}`}>
                        <TableCell>{remito.remito_entrega || "-"}</TableCell>
                        <TableCell>{formatFecha(remito.fecha_para)}</TableCell>
                        <TableCell>{remito.direccion_entrega || "-"}</TableCell>
                        <TableCell>{remito.producto || "-"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            )}
            muiTableHeadCellProps={{
              align: "left",
              sx: {
                fontSize: 16,
                color: "white",
                fontWeight: "normal",
                backgroundColor: "#2471A3",
                borderColor: "black",
              },
            }}
            muiSearchTextFieldProps={{
              placeholder: "Buscar..",
              sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
              variant: "outlined",
              color: "success",
              size: "small",
            }}
            enableDensityToggle={false}
            enableColumnResizing={true}
            muiTableBodyCellProps={{
              align: "left",
              sx: { color: "black" },
            }}
            renderRowActions={({ row }) => (
              <Box>
                <Tooltip arrow placement="right" title="Ver Factura">
                  <span>
                    <IconButton
                      color="primary"
                      disabled={!row.original.id_factura}
                      onClick={() =>
                        verEnviarPDFenvasado(row.original.id_factura, 0)
                      }
                    >
                      <VisibilityIcon />
                    </IconButton>
                  </span>
                </Tooltip>
                {(row.original.id_estado === 261) && (
                  <Tooltip title="Anular Factura" placement="bottom">
                    <IconButton
                      onClick={() => handleAnularFactura(row.original)}
                    >
                      <BlockIcon color="error" />
                    </IconButton>
                  </Tooltip>
                )}

                {row.original.id_estado === 260 && (
                  <Tooltip title="Ver Nota de Credito" placement="bottom">
                    <IconButton
                      onClick={() =>
                        verEnviarPDFenvasado(row.original.id_nc, 0)
                      }
                    >
                      <VisibilityOffIcon color="secondary" />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            )}
          />
        )}
        {anularFactura && (
          <AnularFacturasRemitos
            open={anularFactura}
            setOpen={setAnularFactura}
            factura={rowFactura}
            onClose={handleCloseAnular}
          />
        )}
      </div>
    </div>
  );
}

export default RemitosFacturados;
